import React from "react";
import {Bar} from "react-chartjs-2";
import {NASSAU_CHART_COLOR, OTHER_CHART_COLOR} from '../../../../scripts/constants';
import ChartDataLabels from 'chartjs-plugin-datalabels';

class MygaRateBarChart extends React.Component {

    constructor(props) {
        super(props);
        this.chartReference = React.createRef();
        this.state = {
          initialLoad: true,
          myga4Year: 0,
          capitalOne4Year: 0,
          usBank4Year: 0,
          citiBank4Year: 0
        }
    }

    componentDidMount() {
      if (this.props.dataIsReady) {
        this.processData();
      }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
      if (this.props.mygaData && this.props.bankData && this.state.initialLoad) {
        this.processData();
      }
    }

  processData = () => {
    let myga4Year = this.props.mygaData.find((item) => item.years === '4');
    let findInstitution = name => this.props.bankData.cdRates.find(item => item.institution === name);
    let findRate = (duration, institutionRates) => institutionRates.find(item => item.duration === duration);

    let capitalOne4Year = findRate('4y', findInstitution('Capital One').rates);
    let usBank4Year = findRate('4y', findInstitution('U.S. Bank').rates);
    let citiBank4Year = findRate('4y', findInstitution('Citibank').rates);
    this.setState({initialLoad: false, myga4Year, capitalOne4Year, usBank4Year, citiBank4Year});
  };

  chartOptions = {
      maintainAspectRatio:false,
      legend: {
        display: false
      },
      layout: {
        padding: {
          left: 0,
          right: 0,
          top: 0,
          bottom: 0
        }
      },
      title: {
        display: true,
        fontSize: 16,
        text: '4yr Simple Annuity % Top Bank CD Rates'
      },
      plugins: {
        datalabels: {
          color: 'black',
          anchor: 'end',
          align: 'end',
          formatter: function(value, context) {
            return context.chart.tooltip._data.labels[context.dataIndex];
          }
        }
      },
      tooltips: {
        callbacks: {
          label: function(tooltipItem, data) {
            let label = data.datasets[tooltipItem.datasetIndex].label || '';
            if (label) {
              label += ': ';
            }
            label += parseFloat(tooltipItem.value).toFixed(2) + '%';
            return label;
          }
        }
      },
      scales: {
        yAxes: [{
          position: 'right',
          gridLines: {
            drawOnChartArea: false
          },
          ticks: {
            beginAtZero: true,
            callback: function(value) {
              return value.toFixed(2) + '%';
            }
          }
        }],
        xAxes: [{
          position: 'top',
          gridLines: {
            drawOnChartArea: false,
            drawTicks: false,
            drawBorder: false
          },
          ticks: {
            display: true,
            callback: function(value) {
              return '';
            }
          }
        }]
      }
    };



    render() {
      let chartData = {
        labels: ['Nassau', 'Capital One', 'U.S. Bank', 'Citibank'],
        datasets: [
          {
            data: [this.state.myga4Year.rate, this.state.capitalOne4Year.rate, this.state.usBank4Year.rate, this.state.citiBank4Year.rate],
            backgroundColor: [
              NASSAU_CHART_COLOR,
              OTHER_CHART_COLOR,
              OTHER_CHART_COLOR,
              OTHER_CHART_COLOR
            ]
          }
        ]
      };
      return (
        <Bar ref={this.chartReference}
             plugins={[ChartDataLabels]}
             data={ chartData }
             options={this.chartOptions}
        />
      );
    }
}

export default MygaRateBarChart;


/*

    public func get4yrRatesBarChart(tag: Int) -> BarChartView {

        let barChart = BarChartView()
        barChart.delegate = self;
        barChart.tag = tag;

        //Setup look and feel
        barChart.xAxis.enabled = false

        barChart.leftAxis.enabled = false
        barChart.rightAxis.enabled = true
        barChart.rightAxis.drawGridLinesEnabled = false
        barChart.rightAxis.valueFormatter = DefaultAxisValueFormatter(formatter: getPercentageFormatter())

        barChart.backgroundColor = MYGAStyles.GetOurColor(color: .ViewOverlayBackgroundColor)
        barChart.legend.enabled = false
        barChart.doubleTapToZoomEnabled = false
        barChart.pinchZoomEnabled = true
        barChart.drawMarkers = true

        barChart.marker = getOurMarkerView()

        let rates = get4yrBankRatesWithOurRate(rates: cdRates!)

        var labels: [String] = []

        for rate in rates {

            labels.append(rate.institution ?? "")

        }

        let entry1 = BarChartDataEntry(x: 0.0, y: (rates[0].rate ?? 0.0)/100.0)
        let entry2 = BarChartDataEntry(x: 1.0, y: (rates[1].rate ?? 0.0)/100.0)
        let entry3 = BarChartDataEntry(x: 2.0, y: (rates[2].rate ?? 0.0)/100.0)
        let entry4 = BarChartDataEntry(x: 3.0, y: (rates[3].rate ?? 0.0)/100.0)

        let dataSet = BarChartDataSet(entries: [entry1, entry2, entry3, entry4], label: "Rates")

        dataSet.setColors(MYGAStyles.GetOurColor(color: .ButtonColor), MYGAStyles.GetOurColor(color: .ButtonDisabledColor), MYGAStyles.GetOurColor(color: .ButtonDisabledColor), MYGAStyles.GetOurColor(color: .ButtonDisabledColor))

        dataSet.valueFont = MYGAStyles.GetOurFont(size: 11.0)

        dataSet.valueFormatter = DefaultValueFormatter(block: { (dbl, entry, index, handler) -> String in
            let indexAsInt = NSNumber(value:entry.x).intValue
            return "\(labels[indexAsInt])"
        })
        dataSet.highlightEnabled = true

        barChart.data = BarChartData(dataSet: dataSet)

        barChart.translatesAutoresizingMaskIntoConstraints = false


* */